const initialState = {
    requestingFetchOrders: false,
    successfulFetchOrders: false,
    errorFetchOrders: false,
    orders: {},
    requestingModifyOrderPaymentType: false,
    successfulModifyOrderPaymentType: false,
    errorModifyOrderPaymentType: false,
    requestingCancelOrder: false,
    successfulCancelOrder: false,
    errorCancelOrder: false,
    requestingReSendOrder: false,
    successfulReSendOrder: false,
    errorReSendOrder: false,
    };
  
  const bankingOrdersReducer = (state = initialState, action) => {
    switch (action.type) {
      case "FETCH_BANKING_ORDERS_REQUESTING":
        return {
          ...state,
          requestingFetchOrders: true,
          successfulFetchOrders: false,
          errorFetchOrders: false,
        };
      case "FETCH_BANKING_ORDERS_SUCCESS":
        return {
          ...state,
          requestingFetchOrders: false,
          successfulFetchOrders: true,
          errorFetchOrders: false,
          orders: action.value,
        };
      case "FETCH_BANKING_ORDERS_ERROR":
        return {
          ...state,
          requestingFetchOrders: false,
          successfulFetchOrders: false,
          errorFetchOrders: true,
        };
      case "MODIFY_ORDER_PAYMENT_TYPE_REQUESTING":
        return {
          ...state,
          requestingModifyOrderPaymentType: true,
          successfulModifyOrderPaymentType: false,
          errorModifyOrderPaymentType: false,
        };
      case "MODIFY_ORDER_PAYMENT_TYPE_SUCCESS":
        return {
          ...state,
          requestingModifyOrderPaymentType: false,
          successfulModifyOrderPaymentType: true,
          errorModifyOrderPaymentType: false,
        };
      case "MODIFY_ORDER_PAYMENT_TYPE_ERROR":
        return {
          ...state,
          requestingModifyOrderPaymentType: false,
          successfulModifyOrderPaymentType: false,
          errorModifyOrderPaymentType: true,
        };
      case "MODIFY_ORDER_PAYMENT_TYPE_RESET":
        return {
          ...state,
          requestingModifyOrderPaymentType: false,
          successfulModifyOrderPaymentType: false,
          errorModifyOrderPaymentType: false,
        };
      case "CANCEL_BANKING_ORDER_REQUESTING":
        return {
          ...state,
          requestingCancelOrder: true,
          successfulCancelOrder: false,
          errorCancelOrder: false,
        };
      case "CANCEL_BANKING_ORDER_SUCCESS":
        return {
          ...state,
          requestingCancelOrder: false,
          successfulCancelOrder: true,
          errorCancelOrder: false,
        };
      case "CANCEL_BANKING_ORDER_ERROR":
        return {
          ...state,
          requestingCancelOrder: false,
          successfulCancelOrder: false,
          errorCancelOrder: true,
        };
      case "CANCEL_BANKING_ORDER_RESET":
        return {
          ...state,
          requestingCancelOrder: false,
          successfulCancelOrder: false,
          errorCancelOrder: false,
        };
      case "RESEND_BANKING_ORDER_REQUESTING":
        return {
          ...state,
          requestingReSendOrder: true,
          successfulReSendOrder: false,
          errorReSendOrder: false,
        };
      case "RESEND_BANKING_ORDER_SUCCESS":
        return {
          ...state,
          requestingReSendOrder: false,
          successfulReSendOrder: true,
          errorReSendOrder: false,
        };
      case "RESEND_BANKING_ORDER_ERROR":
        return {
          ...state,
          requestingReSendOrder: false,
          successfulReSendOrder: false,
          errorReSendOrder: true,
        };
      case "RESEND_BANKING_ORDER_RESET":
        return {
          ...state,
          requestingReSendOrder: false,
          successfulReSendOrder: false,
          errorReSendOrder: false,
        };
      default:
        return state;
    }
  };
  
  export default bankingOrdersReducer;
  